import { PageHeader } from "@shared/components/PageHeader";
import React from "react";
import ExecutionHistoryList from "../list/list";

const ExecutionHistoryLanding = () => {
  return (
    <div>
      <div>
        <PageHeader
          title="Execution History"
          subtitle="View and manage execution history for this workflow"
        />
      </div>
      <div className="mt-4">
        <ExecutionHistoryList />
      </div>
    </div>
  );
};

export default ExecutionHistoryLanding;
